$(document).ready(function () {
  function assignWidth() {
    if ($(".alt-prod-select").length > 0) {
      const thumbnailElement = $(".alt-prod-select").children()[0];
      const thumbnailWidth =
        $(".alt-prod-select").length <= 6
          ? thumbnailElement.width + 0
          : thumbnailElement.width;
      const sizeLength = $(".alt-prod-select").width();
      const doubleWidth = thumbnailWidth + 2;

      if ($(".alt-prod-select").length === 0) {
      } else if ($(".alt-prod-select").length <= 4) {
        const singlePic = $(".product_color_slider").width() / 5 - 2;

        $(".alt-prod-select").parent().parent().css("width", `20%`);
        $(".alt-prod-select > img").css("width", `${singlePic}px`);

        $(".s-product__option__choices__label")
          .parent()
          .parent()
          .css("width", "100%");

        $(".s-product__option__choices__label__double")
          .css("width", `100%`)
          .parent()
          .css("width", `calc(40% - 3px)`);

        $(".s-product__option__choices__label")
          .css("width", `100%`)
          .parent()
          .css("width", `calc(20% - 3px)`);
      } else {
        $(".s-product__option__choices__label").css("width", `${sizeLength}px`);
        $(".s-product__option__choices__label__double").css(
          "width",
          `${doubleWidth * 2}px`
        );

        if ($(".alt-prod-select").length < 5) {
          if (window.innerWidth > 480) {
            $(".alt-prod-select > img").css("max-width", "85px");
            $(".s-product__option__choices__label").css("max-width", "85px");
            $(".s-product__option__choices__label__double").css(
              "max-width",
              "174px"
            );
          }
        }

        if ($(".s-product__option__choices").children().length > 5) {
          $(".s-product__option__choices").addClass("flex_wrap");
        } else {
          $(".s-product__option__choices").removeClass("flex_wrap");
        }
      }
    } else {
      $(".s-product__option__choices").css("width", "100%");
      $(".s-product__option__choices > li").css("width", "24.2%");
      $(".s-product__option__choices__label").css("width", "100%");
      $(".s-product__option__choices__label__double").css("width", "174px");
    }
  }

  $(".color-slide-btn-left").css("display", "none");
  // On before slide change
  $(".product_color_slider").on(
    "beforeChange",
    function (event, slick, currentSlide, nextSlide) {
      let x;
      x = slick.slideCount - 5;

      if (nextSlide >= 1) {
        $(".color-slide-btn-left").css("display", "block");
      } else if (nextSlide == 0) {
        $(".color-slide-btn-left").css("display", "none");
      }

      if (nextSlide == x && slick.slideCount > 5) {
        $(".color-slide-btn-right").css("display", "none");
      } else if (nextSlide < x && slick.slideCount > 5) {
        $(".color-slide-btn-right").css("display", "block");
      }
    }
  );

  setInterval(() => {
    assignWidth();
  }, 1000);

  window.addEventListener("resize", assignWidth());
  window.addEventListener("load", assignWidth());
});
